import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAllJury, getAllExternalJury, saveProposalJury, getProposalJury } from '../actions/proposalActions';
import { createExternalUser } from '../actions/userActions';
import { JuryRoles } from '../enums/juryRoles';
import { notifySuccess, notifyError } from './Toast';

const AssignProposalJuryModal = ({ show, onHide, activeProposal }) => {
    const dispatch = useDispatch();
    const { jury, proposalJury, externalUsers, loading } = useSelector(state => state.proposal);
    const { userInfo } = useSelector(state => state.user);

    const [externalName, setExternalName] = useState('');
    const [externalLastname, setExternalLastname] = useState('');
    const [externalEmail, setExternalEmail] = useState('');

    const [userList, setUserList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (show && activeProposal) {
            dispatch(getAllJury(userInfo));
            dispatch(getAllExternalJury(userInfo));
            dispatch(getProposalJury(userInfo, activeProposal));
        }
    }, [show, activeProposal, dispatch, userInfo]);

    useEffect(() => {
        if (!proposalJury) return;

        const normalizeJury = jury.map(user => {
            const id = user.idUsuario.toLowerCase();
            const isJury = proposalJury?.some(
                pj => pj.idUsuario?.toLowerCase() === id.toLowerCase() && pj.rol?.Id.toLowerCase() === JuryRoles.Evaluador.id.toLowerCase()
            );
            const isSupreme = proposalJury?.some(
                pj => pj.idUsuario?.toLowerCase() === id.toLowerCase() && pj.rol?.Id.toLowerCase() === JuryRoles.Dictaminador.id.toLowerCase()
            );

            return {
                userId: id,
                mail: user.emailUsuario || '',
                isSelectedJury: isJury,
                isSelectedSupreme: isSupreme,
                isExternal: false
            };
        });

        const normalizeExternal = externalUsers.map(user => {
            const id = user.EntityId.toLowerCase();
            const isJury = proposalJury.some(
                pj => pj.idUsuario?.toLowerCase() === id.toLowerCase() && pj.rol?.Id.toLowerCase() === JuryRoles.Evaluador.id.toLowerCase()
            );

            return {
                userId: id,
                mail: user.email || '',
                isSelectedJury: isJury,
                isSelectedSupreme: false,
                isExternal: true
            };
        });

        setUserList([...normalizeJury, ...normalizeExternal]);
    }, [jury, externalUsers, proposalJury]);

    const cleanModalForm = () => {
        setUserList([]);
        setExternalLastname('');
        setExternalName('')
        setExternalEmail('')
    };

    const handleHide = () => {
        cleanModalForm();
        onHide();
    };

    const saveSelectedUsers = () => {

        const unifiedList = userList.flatMap(user => {
            const entries = [];

            if (user.isSelectedJury) {
                entries.push({
                    evaluacion: {},
                    idUsuario: user.userId,
                    emailUsuario: user.mail,
                    usuarioExterno: user.isExternal ? { EntityId: user.userId } : null,
                    rol: {
                        Id: JuryRoles.Evaluador.id,
                        nombre: JuryRoles.Evaluador.nombre
                    }
                });
            }

            if (user.isSelectedSupreme) {
                entries.push({
                    evaluacion: {},
                    idUsuario: user.userId,
                    emailUsuario: user.mail,
                    usuarioExterno: user.isExternal ? { EntityId: user.userId } : null,
                    rol: {
                        Id: JuryRoles.Dictaminador.id,
                        nombre: JuryRoles.Dictaminador.nombre
                    }
                });
            }

            return entries;
        });

        if (unifiedList.length === 0) {
            notifyError("Debe seleccionar al menos un evaluador y un responsable para dictaminar la propuesta");
            return;
        }

        dispatch(saveProposalJury(activeProposal, unifiedList, userInfo));
        //handleHide();
    };

    /*const handleUserSelection = (userId) => {
        setSelectedUsers(prevUsers => {
            if (prevUsers.includes(userId)) {
                return prevUsers.filter(id => id != userId);
            } else {
                return [...prevUsers, userId];
            }
        });
    };*/

    /*const handleExternalUserSelection = (userId) => {
        setSelectedExternalUsers(prevUsers => {
            if (prevUsers.includes(userId)) {
                return prevUsers.filter(id => id != userId);
            } else {
                return [...prevUsers, userId];
            }
        });
    };*/

    /*const handleSupremeUserSelection = (userId) => {
        setSelectedSupremeUsers(prevUsers => {
            if (prevUsers.includes(userId)) {
                return prevUsers.filter(id => id != userId);
            } else {
                if (prevUsers.length >= 1) {
                    notifyError('Solo se puede seleccionar un responsable.');
                    return prevUsers;
                } else {
                    return [...prevUsers, userId];
                }
            }
        });
    };*/

    const toggleSelect = (userId) => {
        setUserList(prev =>
            prev.map(user =>
            user.userId === userId
                ? { ...user, isSelectedJury: !user.isSelectedJury }
                : user
            )
        );
    };

    const toggleSupreme = (userId) => {
        setUserList(prev =>
            prev.map(user => {
            if (user.userId === userId) {
                return { ...user, isSelectedSupreme: !user.isSelectedSupreme };
            }
            if (user.isSelectedSupreme) {
                return { ...user, isSelectedSupreme: false };
            }
            return user;
            })
        );
    };

    const handleSubmitExternalUser = (e) => {
        e.preventDefault();

        if (externalName == '' || externalLastname == '' || externalEmail == '') {
            notifyError('Faltan completar datos de usuario externo.');
            return;
        }
        const requestData = {
            nombre: externalName,
            apellido: externalLastname,
            email: externalEmail
        };

        dispatch(createExternalUser(requestData, userInfo, activeProposal)).then(() => {
            setExternalEmail('');
            setExternalName('');
            setExternalLastname('');
        })
    };

    const filteredUserList = userList.filter(user =>
        user.mail.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Modal show={show} onHide={handleHide} dialogClassName="custom-modal-dialog">
            <Modal.Header closeButton>
                <Modal.Title>Asignar evaluadores</Modal.Title>
            </Modal.Header>
            <Modal.Body className="custom-modal-body">
                <div className='row'>
                    <div className='col-md-6 col-lg-5'>
                        <Card bg="light" className="mb-3 rounded-3">
                            <Card.Body>
                                <p className="text-muted mb-4">
                                    Si no encuentra el evaluador deseado en la lista, puede registrar un usuario externo. 
                                    Se le notificará por correo electrónico que ha sido registrado en el sistema como posible jurado de microcredenciales.
                                </p>
                                <Form.Group className="mb-2" controlId="fullName">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control type="text" placeholder="Nombre" required value={externalName} onChange={(e) => setExternalName(e.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-2" controlId="fullName">
                                    <Form.Label>Apellido</Form.Label>
                                    <Form.Control type="text" placeholder="Apellido" required value={externalLastname} onChange={(e) => setExternalLastname(e.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-2" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="Email" required value={externalEmail} onChange={(e) => setExternalEmail(e.target.value)} />
                                </Form.Group>
                                <Button className='btnFinalizarDictamen mt-3' onClick={handleSubmitExternalUser}>Agregar externo</Button>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='col-md-6 col-lg-7'>
                        <Form.Group controlId="search" className="mb-2">
                            <Form.Control
                                type="text"
                                placeholder="Buscar por usuario ..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Form.Group>
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr className="table_head">
                                        <th style={{ width: '20%', textAlign: 'center' }}>Evaluador</th>
                                        <th style={{ width: '20%', textAlign: 'center' }}>Responsable del dictamen</th>
                                        <th style={{ width: '45%', textAlign: 'center' }}>Usuario</th>
                                        <th style={{ width: '15%', textAlign: 'center' }}>Origen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? null : filteredUserList.map((user, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={user.isSelectedJury}
                                                    onChange={() => toggleSelect(user.userId)}
                                                    style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={user.isSelectedSupreme}
                                                    onChange={() => toggleSupreme(user.userId)}
                                                    disabled={user.isExternal}
                                                    style={{ transform: 'scale(1.5)', cursor: user.isExternal ? 'not-allowed' : 'pointer' }}
                                                />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{user.mail}</td>
                                            <td style={{ textAlign: 'center' }}>{user.isExternal ? `Externo` : 'UAI'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleHide}>Cancelar</Button>
                <Button variant="primary" onClick={saveSelectedUsers}>Asignar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignProposalJuryModal;
